import script from "./MainHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainHeader.vue?vue&type=script&setup=true&lang=ts"

import "./MainHeader.vue?vue&type=style&index=0&id=0559b896&scoped=true&lang=sass"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0559b896"]])

export default __exports__